define('video-player-modal/video-player-modal',['require','plugins/dialog','mixpanel-helper'],function (require) {
    var dialog = require('plugins/dialog');
    var mixpanelHelper = require('mixpanel-helper');

    var startTime;
    var endTime;

    var VideoPlayerModal = function () {
        var self = this;

        self.close = function () {
            var seconds;
            var timePlayed;

            endTime = new Date();
            seconds = (endTime.getTime() - startTime.getTime()) / 1000;

            if (seconds > 45) {
                timePlayed = 'over 45 Sec';
            } else if (seconds <= 45 && seconds > 30) {
                timePlayed = '30-45 Sec';
            } else if (seconds <= 30 && seconds > 15) {
                timePlayed = '15-30 Sec';
            } else if (seconds <= 15 && seconds > 5) {
                timePlayed = '5-15 Sec';
            } else if (seconds <= 5 && seconds > 0) {
                timePlayed = '0-5 Sec';
            }
            mixpanelHelper.track('Scheduling Video Closed', {
                timePlayed: timePlayed
            });
            dialog.close(self);
        };

        // Make video responsiveness
        var windowResizingHandler = function () {
            var video = $('#video-container');
            if (video) {
                var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                var h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

                video.width(w > 768 ? 0.52 * w : 0.72 * w);
                video.offset({
                    top: (h - video.height()) / 2,
                    left: (w - video.width()) / 2
                });
            } else {
                window.removeEventListener('resize', windowResizingHandler);
            }
        };

        window.addEventListener('resize', windowResizingHandler);

        $(document).one('click', function (event) {
            if (!$(event.target).closest('#video-container').length) {
                if ($('#video-container').is(':visible')) {
                    self.close();
                }
            }
        });

        self.compositionComplete = function () {
            // Start counting when video modal showed
            startTime = new Date();
        };
    };

    VideoPlayerModal.show = function () {
        return dialog.show(new VideoPlayerModal());
    };

    return VideoPlayerModal;
});

